import ajax from '@/libs/Ajax'

export default {
    querySysCodeList(params) {
        return ajax.get('/aseapi/console/sysmgr/syscodemgr/listSysCode', {params: params})
    },
    saveSysCode(data) {
        return ajax.post('/aseapi/console/sysmgr/syscodemgr/saveSysCode', data)
    },
    updateSysCode(data) {
        return ajax.post('/aseapi/console/sysmgr/syscodemgr/updateSysCode', data)
    },
    delSysCode(params) {
        return ajax.post('/aseapi/console/sysmgr/syscodemgr/deleteSysCode', params)
    }
}
